import { statusColor } from "../../..";
import { getInstanceLocationDisplay } from "../../../logisticsStatus";

const InstanceStatus = props => {
  const value = props.label || "";
  const currentWarehouseMove =
    props?.values?.item?.currentWarehouseMove ||
    props?.values?.currentWarehouseMove ||
    props?.row?.item?.currentWarehouseMove ||
    props?.row?.currentWarehouseMove;
  const location = getInstanceLocationDisplay(currentWarehouseMove);

  return (
    <div className="max-w-200">
      <div
        title={value}
        className={`overflow-hidden text-ellipsis text-base font-medium leading-5 ${statusColor(value)}`}
      >
        {value}
      </div>
      <div
        className="mt-1 truncate text-[11px] font-normal leading-4 text-gray-500"
        title={location.summary}
      >
        {location.primary}
      </div>
      {location.detail && (
        <div
          className="truncate text-[10px] font-normal leading-3 text-gray-400"
          title={`${location.detailLabel}: ${location.detail}`}
        >
          {location.detailLabel}: {location.detail}
        </div>
      )}
    </div>
  );
};

export default InstanceStatus;
